/**
 * Hardened gift socks: always use €0 product variants (neslidosas-zekes-davana).
 * Replaces any paid gift lines. No display-only fake €0 — cart.js price must be 0.
 */
(function () {
  const GIFT_QTY_RULE = 'per_eligible_unit';

  const GIFT_PROP = '_gift';
  const GIFT_PROP_VALUE = 'socks';
  const ELIGIBLE_PROP = '_gift_eligible';
  const STORAGE_KEY = 'atj_gift_socks_variant';

  // Permanent €0 gift catalog (not the paid neslidosas-zekes product)
  const GIFT_PRODUCT = {
    handle: 'neslidosas-zekes-davana',
    productId: 11647071420757,
    variants: [
      {
        id: 55132998500693,
        color: 'Rozā',
        aliases: ['rozā', 'roza', 'pink'],
        available: true,
        price: 0,
        image:
          'https://cdn.shopify.com/s/files/1/1078/8057/9413/files/Flo_Pilates_Grip_Socks_-_Pink_1080x1080_494eef6d-bccf-4809-971a-890b6e84f4ce.webp?v=1789049888',
      },
      {
        id: 55132999352661,
        color: 'Melnas',
        aliases: ['melnas', 'melns', 'melna', 'black'],
        available: true,
        price: 0,
        image:
          'https://cdn.shopify.com/s/files/1/1078/8057/9413/files/Flo_Pilates_Grip_Socks_-_Gray_thumbnail_1080x1080_7ae4c7b3-3b3d-44eb-94ff-b843bfa6a025.webp?v=1789049957',
      },
      {
        id: 55132999385429,
        color: 'Violetas',
        aliases: ['violetas', 'violets', 'violeta', 'purple', 'violet'],
        available: true,
        price: 0,
        image:
          'https://cdn.shopify.com/s/files/1/1078/8057/9413/files/Flo_Pilates_Grip_Socks_-_Purple_Thumbnail_Image_1080x1080_d3250374-c113-4c0e-9b37-d527d7f3f460.webp?v=1789049810',
      },
    ],
  };

  const PAID_SOCKS_HANDLE = 'neslidosas-zekes';

  let syncing = false;
  let selectedVariantId = null;
  let config = null;

  function normalizeColor(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ā/g, 'a')
      .replace(/ē/g, 'e')
      .replace(/ī/g, 'i')
      .replace(/ū/g, 'u')
      .replace(/č/g, 'c')
      .replace(/š/g, 's')
      .replace(/ž/g, 'z')
      .trim();
  }

  function giftVariants() {
    const cfg = readConfig();
    const list = cfg && cfg.variants && cfg.variants.length ? cfg.variants : GIFT_PRODUCT.variants;
    // Prefer catalog entries that are real €0 gift IDs
    const onlyGift = (list || []).filter((v) =>
      GIFT_PRODUCT.variants.some((g) => String(g.id) === String(v.id))
    );
    return onlyGift.length ? onlyGift : GIFT_PRODUCT.variants;
  }

  function findGiftVariantByColor(color) {
    const key = normalizeColor(color);
    const list = GIFT_PRODUCT.variants;
    return (
      list.find((v) => normalizeColor(v.color) === key) ||
      list.find((v) => (v.aliases || []).some((a) => normalizeColor(a) === key)) ||
      list.find((v) => key && normalizeColor(v.color).includes(key)) ||
      null
    );
  }

  function isGiftProductVariantId(id) {
    return GIFT_PRODUCT.variants.some((v) => String(v.id) === String(id));
  }

  function readConfig() {
    if (config) return config;
    const el = document.getElementById('atj-gift-socks-config');
    if (el) {
      try {
        config = JSON.parse(el.textContent);
      } catch (e) {
        config = null;
      }
    }
    if (!config) {
      config = {
        handle: GIFT_PRODUCT.handle,
        qtyRule: GIFT_QTY_RULE,
        eligibleTag: 'free-socks-gift',
        eligibleHandles: [],
        defaultVariantId: GIFT_PRODUCT.variants[0].id,
        variants: GIFT_PRODUCT.variants,
      };
    } else {
      // Force €0 gift product even if Liquid fell back to paid socks
      if (config.handle === PAID_SOCKS_HANDLE || !config.variants?.length) {
        config.handle = GIFT_PRODUCT.handle;
        config.variants = GIFT_PRODUCT.variants;
        config.defaultVariantId = GIFT_PRODUCT.variants[0].id;
      }
      // Remap any paid variant IDs in config to gift IDs by colour
      config.variants = (config.variants || []).map((v) => {
        const fallback = findGiftVariantByColor(v.color);
        if (isGiftProductVariantId(v.id) && Number(v.price) === 0) {
          return {
            ...v,
            image: v.image || fallback?.image || '',
            available: v.available !== false,
          };
        }
        return fallback
          ? {
              ...v,
              id: fallback.id,
              color: fallback.color,
              price: 0,
              available: true,
              image: v.image || fallback.image || '',
            }
          : { ...v, price: 0, image: v.image || '' };
      });
      if (!isGiftProductVariantId(config.defaultVariantId)) {
        const byColor = findGiftVariantByColor(
          config.variants.find((v) => String(v.id) === String(config.defaultVariantId))?.color
        );
        config.defaultVariantId = byColor?.id || GIFT_PRODUCT.variants[0].id;
      }
    }
    config.qtyRule = GIFT_QTY_RULE;
    return config;
  }

  function getVariant(id) {
    return giftVariants().find((v) => String(v.id) === String(id)) || null;
  }

  function getSelectedVariantId() {
    if (selectedVariantId && isGiftProductVariantId(selectedVariantId)) return selectedVariantId;
    const cfg = readConfig();
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored && getVariant(stored)?.available !== false) {
        selectedVariantId = Number(stored);
        return selectedVariantId;
      }
      // Remap old paid variant ids stored in session
      if (stored) {
        selectedVariantId = Number(cfg.defaultVariantId);
        sessionStorage.setItem(STORAGE_KEY, String(selectedVariantId));
        return selectedVariantId;
      }
    } catch (e) {
      /* ignore */
    }
    selectedVariantId = Number(cfg.defaultVariantId);
    return selectedVariantId;
  }

  function setSelectedVariantId(id) {
    let variant = getVariant(id);
    if (!variant) {
      // Colour button may still send paid id — map by closest gift colour from DOM
      const btn = document.querySelector(`[data-atj-gift-socks-swatch][data-variant-id="${id}"]`);
      variant = findGiftVariantByColor(btn?.dataset?.color) || getVariant(readConfig().defaultVariantId);
      id = variant?.id;
    }
    if (!variant || variant.available === false) return;
    selectedVariantId = Number(id);
    try {
      sessionStorage.setItem(STORAGE_KEY, String(selectedVariantId));
    } catch (e) {
      /* ignore */
    }
    syncUi();
    document.dispatchEvent(
      new CustomEvent('atj:gift-socks-change', { detail: { variantId: selectedVariantId, variant } })
    );
  }

  function resolveVariantImage(variant) {
    if (!variant) return '';
    if (variant.image) return variant.image;
    const byId = document.querySelector(
      `[data-atj-gift-socks-swatch][data-variant-id="${variant.id}"]`
    );
    if (byId?.dataset?.image) return byId.dataset.image;
    const byColor = Array.from(document.querySelectorAll('[data-atj-gift-socks-swatch]')).find(
      (btn) => normalizeColor(btn.dataset.color) === normalizeColor(variant.color)
    );
    return byColor?.dataset?.image || '';
  }

  function setThumbImage(img, url) {
    if (!img || !url) return;
    img.src = url;
    // Shopify image_tag may leave srcset pointing at the old colour
    img.removeAttribute('srcset');
    if (img.hasAttribute('sizes')) img.setAttribute('sizes', '56px');
  }

  function syncUi() {
    const variant = getVariant(getSelectedVariantId());
    if (!variant) return;

    document.querySelectorAll('[data-atj-gift-socks-swatch]').forEach((btn) => {
      const mapped = findGiftVariantByColor(btn.dataset.color) || getVariant(btn.dataset.variantId);
      const selected = mapped && String(mapped.id) === String(variant.id);
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      // Keep swatch data-variant-id on the €0 gift variant
      if (mapped) btn.dataset.variantId = String(mapped.id);
    });

    document.querySelectorAll('[data-atj-gift-socks-label]').forEach((el) => {
      el.textContent = variant.color || '';
    });

    const imageUrl = resolveVariantImage(variant);
    if (imageUrl) {
      document.querySelectorAll('[data-atj-gift-socks-thumb]').forEach((img) => {
        setThumbImage(img, imageUrl);
      });
    }

    document.querySelectorAll('[data-sticky-gift-socks]').forEach((el) => {
      el.hidden = false;
      const label = el.querySelector('[data-sticky-gift-socks-label]');
      if (label) label.textContent = variant.color || '';
      const thumb = el.querySelector('[data-sticky-gift-socks-thumb]');
      if (thumb && imageUrl) setThumbImage(thumb, imageUrl);
    });
  }

  function getCartEl() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getProductForm() {
    return (
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form form')
    );
  }

  function getActiveGalleryImageUrl() {
    const active = document.querySelector(
      '.custom-gallery__main-image.is-active, .custom-gallery__main-image.is-visible'
    );
    if (active?.src) return active.currentSrc || active.src;
    return '';
  }

  function getCheckedUpsells() {
    return Array.from(document.querySelectorAll('[data-atj-upsell-check]:checked'))
      .map((input) => ({ id: Number(input.dataset.variantId), quantity: 1 }))
      .filter((item) => item.id);
  }

  function buildGiftLine(qty) {
    const id = getSelectedVariantId();
    if (!id || !isGiftProductVariantId(id)) return null;
    const variant = getVariant(id);
    const properties = { [GIFT_PROP]: GIFT_PROP_VALUE };
    if (variant?.image) properties._atj_image = variant.image;
    return { id: Number(id), quantity: qty, properties };
  }

  async function postAdd(items) {
    const cart = getCartEl();
    const payload = { items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      cart.setActiveElement?.(document.activeElement);
    }

    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (data.status) throw new Error(data.description || data.message || 'Cart add failed');

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'atj-gift-socks', cartData: data });
    }
    if (cart?.renderContents) {
      cart.renderContents(data);
      cart.classList?.remove?.('is-empty');
    } else if (!cart) {
      window.location = window.routes.cart_url;
    }
    return data;
  }

  function setSubmitLoading(form, loading) {
    const productForm = form?.closest('product-form');
    const btn = productForm?.querySelector('[type="submit"]') || form?.querySelector('[type="submit"]');
    const spinner = productForm?.querySelector('.loading__spinner');
    if (!btn) return;
    if (loading) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      spinner?.classList.remove('hidden');
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    }
  }

  function bindSwatches() {
    document.querySelectorAll('[data-atj-gift-socks-swatch]').forEach((btn) => {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      // Remap paid variant ids on the button to €0 gift ids
      const mapped = findGiftVariantByColor(btn.dataset.color);
      if (mapped) btn.dataset.variantId = String(mapped.id);
      btn.addEventListener('click', () => {
        if (btn.disabled || btn.dataset.available === 'false') return;
        setSelectedVariantId(btn.dataset.variantId);
      });
    });
  }

  function bindAtcIntercept() {
    const root = document.querySelector('[data-atj-gift-socks-root]');
    if (!root) return;
    const form = getProductForm();
    if (!form || form.dataset.atjGiftBound === '1') return;
    form.dataset.atjGiftBound = '1';
    form.dataset.atjGiftOwnsSubmit = '1';

    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const formData = new FormData(form);
        const mainId = Number(formData.get('id'));
        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        if (!mainId) return;

        const mainLine = {
          id: mainId,
          quantity,
          properties: { [ELIGIBLE_PROP]: '1' },
        };
        const atjImage = formData.get('properties[_atj_image]') || getActiveGalleryImageUrl();
        if (atjImage) mainLine.properties._atj_image = String(atjImage);

        const giftQty = GIFT_QTY_RULE === 'per_order' ? 1 : quantity;
        const giftLine = buildGiftLine(giftQty);
        const upsells = getCheckedUpsells();

        const items = [mainLine];
        if (giftLine) items.push(giftLine);
        items.push(...upsells);

        setSubmitLoading(form, true);
        postAdd(items)
          .then(() => syncGift())
          .catch((error) => {
            console.error('[atj-gift-socks]', error);
            form.closest('product-form')?.handleErrorMessage?.(error.message || 'Error');
          })
          .finally(() => setSubmitLoading(form, false));
      },
      true
    );
  }

  function isGiftLine(item) {
    return item?.properties && item.properties[GIFT_PROP] === GIFT_PROP_VALUE;
  }

  function isPaidGiftLine(item) {
    if (!isGiftLine(item)) return false;
    if (item.handle === PAID_SOCKS_HANDLE) return true;
    if (Number(item.final_price ?? item.price ?? 0) > 0) return true;
    if (!isGiftProductVariantId(item.variant_id)) return true;
    return false;
  }

  function isEligibleLine(item, cfg) {
    if (!item || isGiftLine(item)) return false;
    if (item.properties && item.properties[ELIGIBLE_PROP] === '1') return true;
    const handles = cfg?.eligibleHandles || [];
    return handles.includes(item.handle);
  }

  function desiredGiftQty(eligibleUnits) {
    if (eligibleUnits <= 0) return 0;
    if (GIFT_QTY_RULE === 'per_order') return 1;
    return eligibleUnits;
  }

  async function fetchCart() {
    const response = await fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    });
    return response.json();
  }

  async function changeLine(idOrKey, quantity) {
    const response = await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: idOrKey, quantity }),
    });
    return response.json();
  }

  async function refreshCartSections(cartData) {
    const cart = getCartEl();
    if (cart?.renderContents && cartData?.sections) {
      cart.renderContents(cartData);
      return;
    }
    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sections = cart.getSectionsToRender().map((s) => s.id).join(',');
      const url = `${window.routes.cart_url}?sections=${encodeURIComponent(sections)}`;
      const sectionHtml = await fetch(url).then((r) => r.json());
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const full = await fetchCart();
        full.sections = sectionHtml;
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'atj-gift-socks-sync', cartData: full });
        if (cart.renderContents) cart.renderContents(full);
      } else {
        window.location.reload();
      }
    }
  }

  function colourFromGiftLine(line) {
    return (
      line?.variant_options?.[0] ||
      line?.options_with_values?.find((o) => /krās|color|colour/i.test(o.name || ''))?.value ||
      line?.variant_title ||
      ''
    );
  }

  async function syncGift() {
    if (syncing) return;
    const runtimeCfg = readConfig();

    syncing = true;
    try {
      let cart = await fetchCart();
      let items = cart.items || [];

      // Replace any PAID gift lines with matching €0 gift variants
      const paidGifts = items.filter(isPaidGiftLine);
      for (const line of paidGifts) {
        const colour = colourFromGiftLine(line);
        const mapped = findGiftVariantByColor(colour) || getVariant(getSelectedVariantId());
        const qty = line.quantity || 1;
        await changeLine(line.key, 0);
        if (mapped) {
          await postAdd([
            {
              id: Number(mapped.id),
              quantity: qty,
              properties: { [GIFT_PROP]: GIFT_PROP_VALUE },
            },
          ]);
          selectedVariantId = Number(mapped.id);
          try {
            sessionStorage.setItem(STORAGE_KEY, String(selectedVariantId));
          } catch (e) {
            /* ignore */
          }
        }
      }

      if (paidGifts.length) {
        cart = await fetchCart();
        items = cart.items || [];
      }

      const eligibleUnits = items
        .filter((item) => isEligibleLine(item, runtimeCfg))
        .reduce((sum, item) => sum + (item.quantity || 0), 0);
      const wantQty = desiredGiftQty(eligibleUnits);
      const giftLines = items.filter(isGiftLine);

      if (wantQty === 0) {
        for (const line of giftLines) {
          await changeLine(line.key, 0);
        }
        if (giftLines.length) {
          const updated = await fetchCart();
          await refreshCartSections(updated);
        }
        decorateGiftLines();
        return;
      }

      let targetVariantId = selectedVariantId;
      const existingFreeGift = giftLines.find(
        (l) => isGiftProductVariantId(l.variant_id) && Number(l.final_price ?? l.price ?? 0) === 0
      );
      // Cart/drawer: keep the colour already in the cart. Only override when the
      // shopper explicitly picked a swatch this page session (selectedVariantId set).
      if (!targetVariantId && existingFreeGift) {
        targetVariantId = existingFreeGift.variant_id;
      } else if (!targetVariantId && giftLines[0]) {
        const mapped = findGiftVariantByColor(colourFromGiftLine(giftLines[0]));
        targetVariantId = mapped?.id || giftLines[0].variant_id;
      }
      if (!targetVariantId || !isGiftProductVariantId(targetVariantId)) {
        targetVariantId = getSelectedVariantId();
      }
      if (!isGiftProductVariantId(targetVariantId)) {
        targetVariantId = runtimeCfg.defaultVariantId || GIFT_PRODUCT.variants[0].id;
      }

      const matching = giftLines.filter((l) => String(l.variant_id) === String(targetVariantId));
      const extras = giftLines.filter((l) => String(l.variant_id) !== String(targetVariantId));

      for (const line of extras) {
        await changeLine(line.key, 0);
      }

      if (matching.length === 0) {
        const giftLine = {
          id: Number(targetVariantId),
          quantity: wantQty,
          properties: { [GIFT_PROP]: GIFT_PROP_VALUE },
        };
        const variant = getVariant(targetVariantId);
        if (variant?.image) giftLine.properties._atj_image = variant.image;
        await postAdd([giftLine]);
      } else {
        const primary = matching[0];
        for (let i = 1; i < matching.length; i++) {
          await changeLine(matching[i].key, 0);
        }
        if (primary.quantity !== wantQty) {
          await changeLine(primary.key, wantQty);
        }
        const updated = await fetchCart();
        await refreshCartSections(updated);
      }

      if (targetVariantId) {
        try {
          sessionStorage.setItem(STORAGE_KEY, String(targetVariantId));
          selectedVariantId = Number(targetVariantId);
        } catch (e) {
          /* ignore */
        }
      }
      decorateGiftLines();
    } catch (error) {
      console.error('[atj-gift-socks] syncGift', error);
    } finally {
      setTimeout(() => {
        syncing = false;
      }, 300);
    }
  }

  function decorateGiftLines() {
    document.querySelectorAll('[data-atj-gift-line], .cart-item[data-atj-gift-socks="1"]').forEach((row) => {
      row.classList.add('atj-cart-item--gift');
    });

    document.querySelectorAll('.cart-item--gift-socks, [data-atj-gift-socks="1"]').forEach((row) => {
      row.classList.add('atj-cart-item--gift');
      row.querySelectorAll('quantity-input, quantity-popover, cart-remove-button, .cart-remove-button').forEach(
        (el) => {
          el.style.display = 'none';
        }
      );
    });
  }

  async function changeGiftColour(lineKey, newVariantId, qty) {
    if (syncing) return;
    syncing = true;
    try {
      let variant = getVariant(newVariantId);
      if (!variant) {
        const btn = document.querySelector(`[data-atj-gift-change-color][data-variant-id="${newVariantId}"]`);
        variant = findGiftVariantByColor(btn?.textContent) || findGiftVariantByColor(btn?.dataset?.color);
      }
      const id = variant?.id || newVariantId;
      if (!isGiftProductVariantId(id)) {
        throw new Error('Gift colour must use €0 gift variant');
      }
      await changeLine(lineKey, 0);
      const properties = { [GIFT_PROP]: GIFT_PROP_VALUE };
      if (variant?.image) properties._atj_image = variant.image;
      await postAdd([{ id: Number(id), quantity: qty || 1, properties }]);
      setSelectedVariantId(id);
      await syncGift();
    } catch (e) {
      console.error('[atj-gift-socks] change colour', e);
      syncing = false;
    }
  }

  function bindDrawerColourChange() {
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-atj-gift-change-color]');
      if (!btn) return;
      event.preventDefault();
      const lineKey = btn.dataset.lineKey;
      const variantId = btn.dataset.variantId;
      const qty = parseInt(btn.dataset.qty, 10) || 1;
      if (!lineKey || !variantId) return;
      changeGiftColour(lineKey, variantId, qty);
    });

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-atj-gift-color-toggle]');
      if (!toggle) return;
      event.preventDefault();
      const menu = toggle.parentElement?.querySelector('[data-atj-gift-color-menu]');
      if (!menu) return;
      menu.hidden = !menu.hidden;
    });
  }

  function bindCartUpdateSync() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source === 'atj-gift-socks' || event?.source === 'atj-gift-socks-sync') {
          decorateGiftLines();
          return;
        }
        clearTimeout(window.__atjGiftSyncTimer);
        window.__atjGiftSyncTimer = setTimeout(() => syncGift(), 200);
      });
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const observer = new MutationObserver(() => decorateGiftLines());
      observer.observe(drawer, { childList: true, subtree: true });
    }
  }

  function injectStickyMirror() {
    const sticky = document.querySelector('[data-atj-sticky-atc]');
    if (!sticky || sticky.querySelector('[data-sticky-gift-socks]')) return;
    const meta = sticky.querySelector('.atj-product-sticky-atc__meta');
    if (!meta) return;
    const variant = getVariant(getSelectedVariantId());
    const wrap = document.createElement('p');
    wrap.className = 'atj-product-sticky-atc__gift';
    wrap.setAttribute('data-sticky-gift-socks', '');
    wrap.innerHTML = `<span class="atj-product-sticky-atc__gift-badge">${(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? 'Gift' : 'Dāvana'}</span> ${(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? 'Socks' : 'Zeķes'}: <span data-sticky-gift-socks-label>${
      variant?.color || ''
    }</span>`;
    meta.appendChild(wrap);
  }

  function init() {
    readConfig();
    const hasPdp = !!document.querySelector('[data-atj-gift-socks-root]');
    if (hasPdp) {
      getSelectedVariantId();
      bindSwatches();
      syncUi();
      bindAtcIntercept();
      injectStickyMirror();
      syncUi();
    }

    window.ATJ_GIFT_SOCKS_FALLBACK = readConfig();
    window.atjSyncGiftSocks = syncGift;

    bindDrawerColourChange();
    bindCartUpdateSync();
    decorateGiftLines();

    if (document.querySelector('cart-drawer, .cart-items, [data-atj-gift-socks-root]')) {
      setTimeout(() => syncGift(), 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
